import { render, staticRenderFns } from "./ConsigneeIndex.vue?vue&type=template&id=268122f8&scoped=true&"
import script from "./ConsigneeIndex.vue?vue&type=script&lang=js&"
export * from "./ConsigneeIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConsigneeIndex.vue?vue&type=style&index=0&id=268122f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268122f8",
  null
  
)

export default component.exports